import { createAction } from 'redux-actions';

export const getAlerts = createAction('GET_ALERTS');
export const getAlertsSuccess = createAction('GET_ALERTS_SUCCESS');
export const getAlertsFailure = createAction('GET_ALERTS_FAILURE');

export const updateAlert = createAction('UPDATE_ALERT');
export const updateAlertSuccess = createAction('UPDATE_ALERT_SUCCESS');
export const updateAlertFailure = createAction('UPDATE_ALERT_FAILURE');

